<!--历史值-->
<template>
  <div class="myhistoryAnalysis">
    <div class="con">
      <div class="tree-left">
        <elUnitTree
          @checkFun="mysearch"
          :dataList="virtualDeviceList"
        ></elUnitTree>
      </div>
      <div class="right-table">
        <div class="search-input-btn" style="width:100%">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">
              <div class="input-small mr-20">
                <span>应用类型组：</span>
                <el-select
                  v-model="apptypeValue"
                  multiple
                  collapse-tags
                  placeholder="请选择"
                  size="small"
                >
                  <el-option
                    label="全选"
                    value="全选"
                    @click.native="selectAll"
                  ></el-option>
                  <el-option
                    v-for="item in apptypeGroups"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="input-small mr-20">
                <span>日期：</span>
                <el-date-picker
                  value-format="timestamp"
                  v-model="datetimeValue"
                  type="daterange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </div>
              <div class="input-small myinput">
                <span>间隔(分钟)：</span>
                <el-select v-model="timeInterval" placeholder="请选择">
                  <el-option
                    v-for="item in times"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>

              <el-button
                type="primary"
                plain
                @click="mysearch"
                class="search-btn"
                >查询</el-button
              >
            </div>
          </el-scrollbar>
        </div>
        <div class="mychart" :style="{ width: '100%', height: heights + 'px' }">
          <vchart style="width:100%;height:100%" ref="vchart"></vchart>
        </div>

        <div class="el-loading-mask" v-show="loading">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import vchart from "@/components/module/chart/vchart.vue";
import elUnitTree from "@/components/module/newTree/elDeviceTree.vue";
export default {
  components: {
    vchart,
    elUnitTree,
  },
  props: [],
  data() {
    return {
      apptypeGroups: this.$store.resourcesStore.state.apptypeGroups,
      heights: document.getElementById("app").clientHeight - 260,
      loading: false,
      nowDevice: {},
      times: [5, 15, 30, 60],
      // nowDevice: {}, //当前选中设备列表
      nowApptypeGroups: [], //当前选中的应用类型组
      bgDate: new Date(new Date().formatByDate()),
      endDate: new Date(),
      checkVariablename: [], //需要显示的变量名称
      timeInterval: 30, //时间间隔,单位是分钟
      // nowSeries: [],
      options: {},
      from2name: {},
      count: 0,
      apptypeValue: ["322b3084ed36478facef59016767d0cc"],
      datetimeValue: [
        new Date(new Date().toLocaleDateString()).getTime(),
        new Date().getTime(),
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date(new Date().toLocaleDateString());
              const start = new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date(new Date().toLocaleDateString());
              const start = new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    debugPage = this;
  },
  mounted() {
    //初始化图表
    this.mysearch();
  },
  computed: {
    nowSelectAppTypeGroupIds() {
      return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(
        this.apptypeGroups
      );
    },
    getReadDeviceTree() {
      return [this.deviceStore.getters.getReadDeviceTree];
    },
    variableStore() {
      return this.$store.variableStore;
    },
    virtualDeviceList() {
      var data = this.$store.deviceStore.getters.getReadDeviceTree;
      return isempty(data) ? [] : [deviceList(data)];
    },
    deviceStore() {
      return this.$store.deviceStore;
    },
    deviceTree() {
      return [this.deviceStore.getters.getReadDeviceTree];
    },
    variableTree() {
      if (isempty(this.nowDevice)) {
        return [];
      }
      return this.variableStore.getters.getVariableTree(this.nowDevice.no);
    },

    apptypes() {
      //当前选中的这些变量类型组下面的变量类型列表
      var list = [];
      this.apptypeGroups.forEach((item) => {
        list = list.concat(
          this.variableStore.getters.getApptypeByGroupId(item.id)
        );
      });
      return list;
    },
    columns() {
      var list = [];
      list.push({
        name: "时间",
        key: "time",
        format(value) {
          return new Date(value).formatByTime();
        },
      });
      this.nowVariableNames.forEach((item) => {
        list.push({
          name: item.substr(item.indexOf(".") + 1),
          key: item,
        });
      });
      return list;
    },
    nowVariableNames() {
      //当前应该显示的变量fromname列表
      var ag = this.nowApptypeGroups.map((item) => {
        return item.id;
      });
      var v1 = this.variableTree.filter((item) => {
        return ag.includes(item.id);
      });
      if (isempty(v1)) {
        return [];
      }
      var v2 = [];
      v1.forEach((item) => {
        item.next.forEach((i) => {
          this.from2name[i.fromName] = i.name;
          v2.push(i.fromName); //name !=  fromName
        });
      });
      return v2;
    },
    timeObject() {
      //时间列表,根据开始结束时间和时间间隔计算
      /* var start = this.bgDate.getTime()
        var end = this.endDate.getTime() + 24 * 60 * 60 * 1000 */
      var start = this.datetimeValue[0];
      var end = this.datetimeValue[1] + 24 * 60 * 60 * 1000;
      var obj = {};
      while (start < end) {
        obj[start] = 0;
        start += this.timeInterval * 60 * 1000;
      }
      return obj;
    },
    nowSeries() {
      if (isempty(this.variableTree)) {
        return [];
      } else {
        var fromnameList = [];
        this.variableTree.forEach((item) => {
          item.next.forEach((i) => {
            fromnameList.push(i.fromName);
          });
        });
        var list = [];
        fromnameList.forEach((item) => {
          var name = this.from2name[item] ? this.from2name[item] : item;
          name = name.subByFirstChar(".");
          list.push({
            name: name,
            fromName: item,
            type: "line",
            smooth: true,
            markPoint: {
              data: [
                {
                  name: "最大值",
                  formatter: "{b}:{c}",
                  type: "max",
                },
                {
                  name: "最小值",
                  formatter: "{b}:{c}",
                  type: "min",
                },
              ],
            },
            symbol: "emptyCircle",
            symbolSize: 20,
            sampling: "average",
            data: [],
          });
        });
        return list;
      }
    },
  },
  watch: {
    datetimeValue() {
      this.searchHistory();
    },
    nowDevice(nv, ov) {
      this.timeToValue = {};
      this.searchHistory();
    },
    timeObject(nv, ov) {
      this.setSeries(this.timeObject);
    },
    apptypeValue(nv, ov) {
      this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", nv);
      let list = [];
      if (!isempty(nv)) {
        nv.forEach((item) => {
          this.apptypeGroups.forEach((item2) => {
            if (item == item2.id) {
              list.push(item2);
            }
          });
        });
      }
      this.nowApptypeGroups = list;
      this.searchHistory();
    },
  },
  methods: {
    getMath(index) {
      if (!index) {
        index = 10;
      }
      var min = index - index / 10; // 确保min是整数
      var max = index + index / 10; // 确保max是整数
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    mysearch() {
      var d = {
        title: {
          left: "left",
          textStyle: {
            fontSize: 16,
            fontWeight: "normal",
            color: "#1a1a1a",
          },
        },
        toolbox: {
          show: true,
          showTitle: true,
          top: "-5",
          right: "50",
          feature: {
            magicType: {
              type: ["line", "bar", "stack", "tiled"],
              title: {
                line: "切换为折线图",
                bar: "切换为柱状图",
                stack: "切换为堆叠",
                tiled: "切换为平铺",
              },
            },
            saveAsImage: {
              show: true,
              title: "下载图片",
            },
          },
        },
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            animation: false,
          },
        },
        xAxis: {
          type: "time",
          splitLine: {
            show: false,
            lineStyle: {
              width: 0.5,
              type: "solid",
            },
          },
        },
        yAxis: {
          lineStyle: {
            show: false,
            width: 1,
            type: "solid",
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            start: 1,
            end: 10,
            handleSize: 8,
          },
          {
            type: "inside",
            start: 1,
            end: 10,
          },
        ],
        grid: {
          left: "5%",
          right: "2%",
          bottom: "100",
          containLabel: true,
        },
        legend: {
          data: [
            {
              name: "总有功功率",
              icon: "roundRect",
            },
            {
              name: "A相电流",
              icon: "roundRect",
            },
            {
              name: "B相电流",
              icon: "roundRect",
            },
            {
              name: "C相电流",
              icon: "roundRect",
            },
          ],
          type: "scroll",
          bottom: "60px",
          tooltip: {
            show: true,
          },
          selected: {
            总有功功率: true,
            A相电流: true,
            B相电流: true,
            C相电流: true,
          },
        },
        series: [
          {
            name: "总有功功率",
            fromName: "设备机电总进线数显表.总有功功率",
            type: "line",
            smooth: true,
            symbol: "emptyCircle",
            sampling: "average",
            markPoint: {
              data: [
                {
                  name: "最大值",
                  formatter: "{b}:{c}",
                  type: "max",
                },
                {
                  name: "最小值",
                  formatter: "{b}:{c}",
                  type: "min",
                },
              ],
            },
            data: [
              [1712680200000, "0.00"],
              [1712682000000, "0.00"],
              [1712683800000, "0.00"],
              [1712685600000, "0.00"],
              [1712687400000, "0.00"],
              [1712689200000, "0.00"],
              [1712691000000, "0.00"],
              [1712692800000, "0.00"],
              [1712694600000, "0.00"],
              [1712696400000, "0.00"],
              [1712698200000, "0.00"],
              [1712700000000, "0.00"],
              [1712701800000, "0.00"],
              [1712703600000, "0.00"],
              [1712705400000, "0.00"],
              [1712707200000, "0.00"],
              [1712709000000, "0.00"],
              [1712710800000, "0.00"],
              [1712712600000, "0.00"],
              [1712714400000, "0.00"],
              [1712716200000, "0.00"],
              [1712718000000, "0.00"],
              [1712719800000, "0.00"],
              [1712721600000, "0.00"],
              [1712723400000, "0.00"],
              [1712725200000, "0.00"],
              [1712727000000, "0.00"],
              [1712728800000, "0.00"],
              [1712730600000, "0.00"],
              [1712732400000, "0.00"],
              [1712734200000, "0.00"],
              [1712736000000, "0.00"],
              [1712737800000, "0.00"],
              [1712739600000, "0.00"],
              [1712741400000, "0.00"],
              [1712743200000, "0.00"],
              [1712745000000, "0.00"],
              [1712746800000, "0.00"],
              [1712748600000, "0.00"],
              [1712750400000, "0.00"],
              [1712752200000, "0.00"],
              [1712754000000, "0.00"],
              [1712755800000, "0.00"],
              [1712757600000, "0.00"],
              [1712759400000, "0.00"],
              [1712761200000, "0.00"],
              [1712763000000, "0.00"],
              [1712764800000, "0.00"],
              [1712766600000, "0.00"],
              [1712768400000, "0.00"],
              [1712770200000, "0.00"],
              [1712772000000, "0.00"],
              [1712773800000, "0.00"],
              [1712775600000, "0.00"],
              [1712777400000, "0.00"],
              [1712779200000, "0.00"],
              [1712781000000, "0.00"],
              [1712782800000, "0.00"],
              [1712784600000, "0.00"],
              [1712786400000, "0.00"],
              [1712788200000, "0.00"],
              [1712790000000, "0.00"],
              [1712791800000, "0.00"],
              [1712793600000, "0.00"],
              [1712795400000, "0.00"],
              [1712797200000, "0.00"],
              [1712799000000, "0.00"],
              [1712800800000, "0.00"],
              [1712802600000, "0.00"],
              [1712804400000, "0.00"],
              [1712806200000, "0.00"],
              [1712808000000, "0.00"],
              [1712809800000, "0.00"],
              [1712811600000, "0.00"],
              [1712813400000, "0.00"],
              [1712815200000, "0.00"],
              [1712817000000, "0.00"],
              [1712818800000, "0.00"],
              [1712820600000, "0.00"],
              [1712822400000, "0.00"],
              [1712824200000, null],
              [1712826000000, null],
              [1712827800000, "0.00"],
              [1712829600000, "0.00"],
              [1712831400000, "0.00"],
              [1712833200000, "0.00"],
              [1712835000000, "0.00"],
              [1712836800000, "0.00"],
              [1712838600000, "0.00"],
              [1712840400000, "0.00"],
              [1712842200000, "0.00"],
              [1712844000000, "0.00"],
              [1712845800000, "0.00"],
              [1712847600000, "0.00"],
              [1712849400000, "0.00"],
              [1712851200000, "0.00"],
              [1712853000000, "0.00"],
              [1712854800000, "0.00"],
              [1712856600000, "0.00"],
              [1712858400000, "0.00"],
              [1712860200000, "0.00"],
              [1712862000000, "0.00"],
              [1712863800000, "0.00"],
              [1712865600000, "0.00"],
              [1712867400000, "0.00"],
              [1712869200000, "0.00"],
              [1712871000000, "0.00"],
              [1712872800000, "0.00"],
              [1712874600000, "0.00"],
              [1712876400000, "0.00"],
              [1712878200000, "0.00"],
              [1712880000000, "0.00"],
              [1712881800000, "0.00"],
              [1712883600000, "0.00"],
              [1712885400000, "0.00"],
              [1712887200000, "0.00"],
              [1712889000000, "0.00"],
              [1712890800000, "0.00"],
              [1712892600000, "0.00"],
              [1712894400000, "0.00"],
              [1712896200000, "0.00"],
              [1712898000000, "0.00"],
              [1712899800000, "0.00"],
              [1712901600000, "0.00"],
              [1712903400000, "0.00"],
              [1712905200000, "0.00"],
              [1712907000000, "0.00"],
              [1712908800000, "0.00"],
              [1712910600000, "0.00"],
              [1712912400000, "0.00"],
              [1712914200000, "0.00"],
              [1712916000000, "0.00"],
              [1712917800000, "0.00"],
              [1712919600000, "0.00"],
              [1712921400000, "0.00"],
              [1712923200000, "0.00"],
              [1712925000000, "0.00"],
              [1712926800000, "0.00"],
              [1712928600000, "0.00"],
              [1712930400000, "0.00"],
              [1712932200000, "0.00"],
              [1712934000000, "0.00"],
              [1712935800000, "0.00"],
            ],
          },
          {
            name: "A相电流",
            fromName: "设备机电总进线数显表.A相电流",
            type: "line",
            smooth: true,
            symbol: "emptyCircle",
            sampling: "average",
            markPoint: {
              data: [
                {
                  name: "最大值",
                  formatter: "{b}:{c}",
                  type: "max",
                },
                {
                  name: "最小值",
                  formatter: "{b}:{c}",
                  type: "min",
                },
              ],
            },
            data: [
              [1712680200000, this.aaa()],
              [1712682000000, this.aaa()],
              [1712683800000, this.aaa()],
              [1712685600000, this.aaa()],
              [1712687400000, this.aaa()],
              [1712689200000, this.aaa()],
              [1712691000000, this.aaa()],
              [1712692800000, this.aaa()],
              [1712694600000, this.aaa()],
              [1712696400000, this.aaa()],
              [1712698200000, this.aaa()],
              [1712700000000, this.aaa()],
              [1712701800000, this.aaa()],
              [1712703600000, this.aaa()],
              [1712705400000, this.aaa()],
              [1712707200000, this.aaa()],
              [1712709000000, this.aaa()],
              [1712710800000, this.aaa()],
              [1712712600000, this.aaa()],
              [1712714400000, this.aaa()],
              [1712716200000, this.aaa()],
              [1712718000000, this.aaa()],
              [1712719800000, this.aaa()],
              [1712721600000, this.aaa()],
              [1712723400000, this.aaa()],
              [1712725200000, this.aaa()],
              [1712727000000, this.aaa()],
              [1712728800000, this.aaa()],
              [1712730600000, this.aaa()],
              [1712732400000, this.aaa()],
              [1712734200000, this.aaa()],
              [1712736000000, this.aaa()],
              [1712737800000, this.aaa()],
              [1712739600000, this.aaa()],
              [1712741400000, this.aaa()],
              [1712743200000, this.aaa()],
              [1712745000000, this.aaa()],
              [1712746800000, this.aaa()],
              [1712748600000, this.aaa()],
              [1712750400000, this.aaa()],
              [1712752200000, this.aaa()],
              [1712754000000, this.aaa()],
              [1712755800000, this.aaa()],
              [1712757600000, this.aaa()],
              [1712759400000, this.aaa()],
              [1712761200000, this.aaa()],
              [1712763000000, this.aaa()],
              [1712764800000, this.aaa()],
              [1712766600000, this.aaa()],
              [1712768400000, this.aaa()],
              [1712770200000, this.aaa()],
              [1712772000000, this.aaa()],
              [1712773800000, this.aaa()],
              [1712775600000, this.aaa()],
              [1712777400000, this.aaa()],
              [1712779200000, this.aaa()],
              [1712781000000, this.aaa()],
              [1712782800000, this.aaa()],
              [1712784600000, this.aaa()],
              [1712786400000, this.aaa()],
              [1712788200000, this.aaa()],
              [1712790000000, this.aaa()],
              [1712791800000, this.aaa()],
              [1712793600000, this.aaa()],
              [1712795400000, this.aaa()],
              [1712797200000, this.aaa()],
              [1712799000000, this.aaa()],
              [1712800800000, this.aaa()],
              [1712802600000, this.aaa()],
              [1712804400000, this.aaa()],
              [1712806200000, this.aaa()],
              [1712808000000, this.aaa()],
              [1712809800000, this.aaa()],
              [1712811600000, this.aaa()],
              [1712813400000, this.aaa()],
              [1712815200000, this.aaa()],
              [1712817000000, this.aaa()],
              [1712818800000, this.aaa()],
              [1712820600000, this.aaa()],
              [1712822400000, this.aaa()],
              [1712824200000, null],
              [1712826000000, null],
              [1712827800000, this.aaa()],
              [1712829600000, this.aaa()],
              [1712831400000, this.aaa()],
              [1712833200000, this.aaa()],
              [1712835000000, this.aaa()],
              [1712836800000, this.aaa()],
              [1712838600000, this.aaa()],
              [1712840400000, this.aaa()],
              [1712842200000, this.aaa()],
              [1712844000000, this.aaa()],
              [1712845800000, this.aaa()],
              [1712847600000, this.aaa()],
              [1712849400000, this.aaa()],
              [1712851200000, this.aaa()],
              [1712853000000, this.aaa()],
              [1712854800000, this.aaa()],
              [1712856600000, this.aaa()],
              [1712858400000, this.aaa()],
              [1712860200000, this.aaa()],
              [1712862000000, this.aaa()],
              [1712863800000, this.aaa()],
              [1712865600000, this.aaa()],
              [1712867400000, this.aaa()],
              [1712869200000, this.aaa()],
              [1712871000000, this.aaa()],
              [1712872800000, this.aaa()],
              [1712874600000, this.aaa()],
              [1712876400000, this.aaa()],
              [1712878200000, this.aaa()],
              [1712880000000, this.aaa()],
              [1712881800000, this.aaa()],
              [1712883600000, this.aaa()],
              [1712885400000, this.aaa()],
              [1712887200000, this.aaa()],
              [1712889000000, this.aaa()],
              [1712890800000, this.aaa()],
              [1712892600000, this.aaa()],
              [1712894400000, this.aaa()],
              [1712896200000, this.aaa()],
              [1712898000000, this.aaa()],
              [1712899800000, this.aaa()],
              [1712901600000, this.aaa()],
              [1712903400000, this.aaa()],
              [1712905200000, this.aaa()],
              [1712907000000, this.aaa()],
              [1712908800000, this.aaa()],
              [1712910600000, this.aaa()],
              [1712912400000, this.aaa()],
              [1712914200000, this.aaa()],
              [1712916000000, this.aaa()],
              [1712917800000, this.aaa()],
              [1712919600000, this.aaa()],
              [1712921400000, this.aaa()],
              [1712923200000, this.aaa()],
              [1712925000000, this.aaa()],
              [1712926800000, this.aaa()],
              [1712928600000, this.aaa()],
              [1712930400000, this.aaa()],
              [1712932200000, this.aaa()],
              [1712934000000, this.aaa()],
              [1712935800000, this.aaa()],
            ],
          },
          {
            name: "B相电流",
            fromName: "设备机电总进线数显表.B相电流",
            type: "line",
            smooth: true,
            symbol: "emptyCircle",
            sampling: "average",
            markPoint: {
              data: [
                {
                  name: "最大值",
                  formatter: "{b}:{c}",
                  type: "max",
                },
                {
                  name: "最小值",
                  formatter: "{b}:{c}",
                  type: "min",
                },
              ],
            },
            data: [
              [1712680200000, this.aaa()],
              [1712682000000, this.aaa()],
              [1712683800000, this.aaa()],
              [1712685600000, this.aaa()],
              [1712687400000, this.aaa()],
              [1712689200000, this.aaa()],
              [1712691000000, this.aaa()],
              [1712692800000, this.aaa()],
              [1712694600000, this.aaa()],
              [1712696400000, this.aaa()],
              [1712698200000, this.aaa()],
              [1712700000000, this.aaa()],
              [1712701800000, this.aaa()],
              [1712703600000, this.aaa()],
              [1712705400000, this.aaa()],
              [1712707200000, this.aaa()],
              [1712709000000, this.aaa()],
              [1712710800000, this.aaa()],
              [1712712600000, this.aaa()],
              [1712714400000, this.aaa()],
              [1712716200000, this.aaa()],
              [1712718000000, this.aaa()],
              [1712719800000, this.aaa()],
              [1712721600000, this.aaa()],
              [1712723400000, this.aaa()],
              [1712725200000, this.aaa()],
              [1712727000000, this.aaa()],
              [1712728800000, this.aaa()],
              [1712730600000, this.aaa()],
              [1712732400000, this.aaa()],
              [1712734200000, this.aaa()],
              [1712736000000, this.aaa()],
              [1712737800000, this.aaa()],
              [1712739600000, this.aaa()],
              [1712741400000, this.aaa()],
              [1712743200000, this.aaa()],
              [1712745000000, this.aaa()],
              [1712746800000, this.aaa()],
              [1712748600000, this.aaa()],
              [1712750400000, this.aaa()],
              [1712752200000, this.aaa()],
              [1712754000000, this.aaa()],
              [1712755800000, this.aaa()],
              [1712757600000, this.aaa()],
              [1712759400000, this.aaa()],
              [1712761200000, this.aaa()],
              [1712763000000, this.aaa()],
              [1712764800000, this.aaa()],
              [1712766600000, this.aaa()],
              [1712768400000, this.aaa()],
              [1712770200000, this.aaa()],
              [1712772000000, this.aaa()],
              [1712773800000, this.aaa()],
              [1712775600000, this.aaa()],
              [1712777400000, this.aaa()],
              [1712779200000, this.aaa()],
              [1712781000000, this.aaa()],
              [1712782800000, this.aaa()],
              [1712784600000, this.aaa()],
              [1712786400000, this.aaa()],
              [1712788200000, this.aaa()],
              [1712790000000, this.aaa()],
              [1712791800000, this.aaa()],
              [1712793600000, this.aaa()],
              [1712795400000, this.aaa()],
              [1712797200000, this.aaa()],
              [1712799000000, this.aaa()],
              [1712800800000, this.aaa()],
              [1712802600000, this.aaa()],
              [1712804400000, this.aaa()],
              [1712806200000, this.aaa()],
              [1712808000000, this.aaa()],
              [1712809800000, this.aaa()],
              [1712811600000, this.aaa()],
              [1712813400000, this.aaa()],
              [1712815200000, this.aaa()],
              [1712817000000, this.aaa()],
              [1712818800000, this.aaa()],
              [1712820600000, this.aaa()],
              [1712822400000, this.aaa()],
              [1712824200000, null],
              [1712826000000, null],
              [1712827800000, this.aaa()],
              [1712829600000, this.aaa()],
              [1712831400000, this.aaa()],
              [1712833200000, this.aaa()],
              [1712835000000, this.aaa()],
              [1712836800000, this.aaa()],
              [1712838600000, this.aaa()],
              [1712840400000, this.aaa()],
              [1712842200000, this.aaa()],
              [1712844000000, this.aaa()],
              [1712845800000, this.aaa()],
              [1712847600000, this.aaa()],
              [1712849400000, this.aaa()],
              [1712851200000, this.aaa()],
              [1712853000000, this.aaa()],
              [1712854800000, this.aaa()],
              [1712856600000, this.aaa()],
              [1712858400000, this.aaa()],
              [1712860200000, this.aaa()],
              [1712862000000, this.aaa()],
              [1712863800000, this.aaa()],
              [1712865600000, this.aaa()],
              [1712867400000, this.aaa()],
              [1712869200000, this.aaa()],
              [1712871000000, this.aaa()],
              [1712872800000, this.aaa()],
              [1712874600000, this.aaa()],
              [1712876400000, this.aaa()],
              [1712878200000, this.aaa()],
              [1712880000000, this.aaa()],
              [1712881800000, this.aaa()],
              [1712883600000, this.aaa()],
              [1712885400000, this.aaa()],
              [1712887200000, this.aaa()],
              [1712889000000, this.aaa()],
              [1712890800000, this.aaa()],
              [1712892600000, this.aaa()],
              [1712894400000, this.aaa()],
              [1712896200000, this.aaa()],
              [1712898000000, this.aaa()],
              [1712899800000, this.aaa()],
              [1712901600000, this.aaa()],
              [1712903400000, this.aaa()],
              [1712905200000, this.aaa()],
              [1712907000000, this.aaa()],
              [1712908800000, this.aaa()],
              [1712910600000, this.aaa()],
              [1712912400000, this.aaa()],
              [1712914200000, this.aaa()],
              [1712916000000, this.aaa()],
              [1712917800000, this.aaa()],
              [1712919600000, this.aaa()],
              [1712921400000, this.aaa()],
              [1712923200000, this.aaa()],
              [1712925000000, this.aaa()],
              [1712926800000, this.aaa()],
              [1712928600000, this.aaa()],
              [1712930400000, this.aaa()],
              [1712932200000, this.aaa()],
              [1712934000000, this.aaa()],
              [1712935800000, this.aaa()],
            ],
          },
          {
            name: "C相电流",
            fromName: "设备机电总进线数显表.C相电流",
            type: "line",
            smooth: true,
            symbol: "emptyCircle",
            sampling: "average",
            markPoint: {
              data: [
                {
                  name: "最大值",
                  formatter: "{b}:{c}",
                  type: "max",
                },
                {
                  name: "最小值",
                  formatter: "{b}:{c}",
                  type: "min",
                },
              ],
            },
            data: [
              [1712680200000, this.aaa()],
              [1712682000000, this.aaa()],
              [1712683800000, this.aaa()],
              [1712685600000, this.aaa()],
              [1712687400000, this.aaa()],
              [1712689200000, this.aaa()],
              [1712691000000, this.aaa()],
              [1712692800000, this.aaa()],
              [1712694600000, this.aaa()],
              [1712696400000, this.aaa()],
              [1712698200000, this.aaa()],
              [1712700000000, this.aaa()],
              [1712701800000, this.aaa()],
              [1712703600000, this.aaa()],
              [1712705400000, this.aaa()],
              [1712707200000, this.aaa()],
              [1712709000000, this.aaa()],
              [1712710800000, this.aaa()],
              [1712712600000, this.aaa()],
              [1712714400000, this.aaa()],
              [1712716200000, this.aaa()],
              [1712718000000, this.aaa()],
              [1712719800000, this.aaa()],
              [1712721600000, this.aaa()],
              [1712723400000, this.aaa()],
              [1712725200000, this.aaa()],
              [1712727000000, this.aaa()],
              [1712728800000, this.aaa()],
              [1712730600000, this.aaa()],
              [1712732400000, this.aaa()],
              [1712734200000, this.aaa()],
              [1712736000000, this.aaa()],
              [1712737800000, this.aaa()],
              [1712739600000, this.aaa()],
              [1712741400000, this.aaa()],
              [1712743200000, this.aaa()],
              [1712745000000, this.aaa()],
              [1712746800000, this.aaa()],
              [1712748600000, this.aaa()],
              [1712750400000, this.aaa()],
              [1712752200000, this.aaa()],
              [1712754000000, this.aaa()],
              [1712755800000, this.aaa()],
              [1712757600000, this.aaa()],
              [1712759400000, this.aaa()],
              [1712761200000, this.aaa()],
              [1712763000000, this.aaa()],
              [1712764800000, this.aaa()],
              [1712766600000, this.aaa()],
              [1712768400000, this.aaa()],
              [1712770200000, this.aaa()],
              [1712772000000, this.aaa()],
              [1712773800000, this.aaa()],
              [1712775600000, this.aaa()],
              [1712777400000, this.aaa()],
              [1712779200000, this.aaa()],
              [1712781000000, this.aaa()],
              [1712782800000, this.aaa()],
              [1712784600000, this.aaa()],
              [1712786400000, this.aaa()],
              [1712788200000, this.aaa()],
              [1712790000000, this.aaa()],
              [1712791800000, this.aaa()],
              [1712793600000, this.aaa()],
              [1712795400000, this.aaa()],
              [1712797200000, this.aaa()],
              [1712799000000, this.aaa()],
              [1712800800000, this.aaa()],
              [1712802600000, this.aaa()],
              [1712804400000, this.aaa()],
              [1712806200000, this.aaa()],
              [1712808000000, this.aaa()],
              [1712809800000, this.aaa()],
              [1712811600000, this.aaa()],
              [1712813400000, this.aaa()],
              [1712815200000, this.aaa()],
              [1712817000000, this.aaa()],
              [1712818800000, this.aaa()],
              [1712820600000, this.aaa()],
              [1712822400000, this.aaa()],
              [1712824200000, null],
              [1712826000000, null],
              [1712827800000, this.aaa()],
              [1712829600000, this.aaa()],
              [1712831400000, this.aaa()],
              [1712833200000, this.aaa()],
              [1712835000000, this.aaa()],
              [1712836800000, this.aaa()],
              [1712838600000, this.aaa()],
              [1712840400000, this.aaa()],
              [1712842200000, this.aaa()],
              [1712844000000, this.aaa()],
              [1712845800000, this.aaa()],
              [1712847600000, this.aaa()],
              [1712849400000, this.aaa()],
              [1712851200000, this.aaa()],
              [1712853000000, this.aaa()],
              [1712854800000, this.aaa()],
              [1712856600000, this.aaa()],
              [1712858400000, this.aaa()],
              [1712860200000, this.aaa()],
              [1712862000000, this.aaa()],
              [1712863800000, this.aaa()],
              [1712865600000, this.aaa()],
              [1712867400000, this.aaa()],
              [1712869200000, this.aaa()],
              [1712871000000, this.aaa()],
              [1712872800000, this.aaa()],
              [1712874600000, this.aaa()],
              [1712876400000, this.aaa()],
              [1712878200000, this.aaa()],
              [1712880000000, this.aaa()],
              [1712881800000, this.aaa()],
              [1712883600000, this.aaa()],
              [1712885400000, this.aaa()],
              [1712887200000, this.aaa()],
              [1712889000000, this.aaa()],
              [1712890800000, this.aaa()],
              [1712892600000, this.aaa()],
              [1712894400000, this.aaa()],
              [1712896200000, this.aaa()],
              [1712898000000, this.aaa()],
              [1712899800000, this.aaa()],
              [1712901600000, this.aaa()],
              [1712903400000, this.aaa()],
              [1712905200000, this.aaa()],
              [1712907000000, this.aaa()],
              [1712908800000, this.aaa()],
              [1712910600000, this.aaa()],
              [1712912400000, this.aaa()],
              [1712914200000, this.aaa()],
              [1712916000000, this.aaa()],
              [1712917800000, this.aaa()],
              [1712919600000, this.aaa()],
              [1712921400000, this.aaa()],
              [1712923200000, this.aaa()],
              [1712925000000, this.aaa()],
              [1712926800000, this.aaa()],
              [1712928600000, this.aaa()],
              [1712930400000, this.aaa()],
              [1712932200000, this.aaa()],
              [1712934000000, this.aaa()],
              [1712935800000, this.aaa()],
            ],
          },
        ],
      };
      this.$refs.vchart.setData(d, true);
    },
    aaa(v) {
      if (v) {
        return Math.floor(Math.random() * 10) * v;
      }
      return Math.floor(Math.random() * 10) + 20;
    },
    checkFun(val) {
      this.nowDevice = val[0];
    },
    selectAll() {
      //全选 先判断是否有选中的，有选中就清空
      if (this.apptypeValue.length == 1) {
        this.nowApptypeGroup = this.apptypeGroups;
        let idList = [];
        this.apptypeGroups.forEach((item) => {
          idList.push(item.id);
        });
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", idList);
        this.apptypeValue = idList;
      } else {
        this.nowApptypeGroup = [];
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", []);
        this.apptypeValue = [];
      }
    },

    searchHistory() {
      if (
        this.datetimeValue[1] - this.datetimeValue[0] >=
        90 * 24 * 60 * 60 * 1000
      ) {
        this.$message({
          message: "时间跨度请勿超过90天",
          type: "warning",
        });
        return;
      }
      if (isempty(this.nowSeries)) {
        // 防止series undefiend
        setTimeout(() => {
          if (this.count < 10) {
            this.searchHistory();
            this.count++;
          }
        }, 100);
        return;
      }
      this.count = 0;
      var values = historyValues();
      //查询数据
      this.loading = true;
      // this.$dialogMethod.showLoading("正在查询数据...")
      this.$api.historyApi.searchDeviceHistory(
        this.nowDevice.no,
        this.datetimeValue[0],
        this.datetimeValue[1],
        (respon) => {
          //清空当前数据
          var nowSeries = this.nowSeries;
          // console.log("this.nowSeries",this.nowSeries);
          for (var i = 0, len = nowSeries.length; i < len; i++) {
            nowSeries[i].data.clear();
          }
          // this.$dialogMethod.showLoading("正在加载...")
          //把历史值数据放到数据列中
          for (var i = 0, len = respon.length; i < len; i++) {
            var item = respon[i];
            for (var i1 = 0, len1 = item.next.length; i1 < len1; i1++) {
              var year = item.next[i1];
              for (var i2 = 0, len2 = year.next.length; i2 < len2; i2++) {
                var month = year.next[i2];
                var monthNext = month.next;
                for (var i3 = 0, len3 = monthNext.length; i3 < len3; i3++) {
                  var day = monthNext[i3];
                  var dayNext = day.next;
                  for (var i4 = 0, len4 = dayNext.length; i4 < len4; i4++) {
                    //具体数据列
                    var data = dayNext[i4];
                    var values = data.data;
                    var variablename = data.variablename;
                    var nowDateTime = new Date(
                      year.name + "/" + month.name + "/" + day.name
                    ).getTime();
                    var series = nowSeries.find((s) => {
                      return s.fromName == variablename; //必须为 fromName
                    });
                    if (series == null) {
                      continue;
                    }
                    var nValues = values.map((value, index) => {
                      return [nowDateTime + index * 5 * 60 * 1000, value];
                    });
                    if (series.data != undefined) {
                      series.data = series.data.concat(nValues);
                    } else {
                      series.data = nValues;
                    }
                  }
                }
              }
            }
          }
          this.setSeries(this.timeObject);
          this.loading = false;
          // this.$dialogMethod.closeLoading()
        },
        (respon) => {
          // this.$dialogMethod.closeLoading();
          this.$message({
            message: respon,
            type: "error",
          });
          this.loading = false;
        }
      );
    },
    setSeries(timeObject) {
      // console.log("timeObject",timeObject);
      var nl = [];
      var fromnameList = this.nowVariableNames;
      // console.log("nowVariableNames",fromnameList);
      var legend = [];
      var selectLegend = {};
      var count = 0;
      //根据当前选中类型组和时间间隔过滤数据然后设置一下
      for (var i = 0, len = this.nowSeries.length; i < len; i++) {
        var item = this.nowSeries[i];
        if (!fromnameList.includes(item.fromName)) {
          continue;
        }
        var nitem = {
          name: item.name,
          fromName: item.fromName,
          type: item.type,
          smooth: item.smooth,
          symbol: item.symbol,
          sampling: item.sampling,
          markPoint: {
            data: [
              {
                name: "最大值",
                formatter: "{b}:{c}",
                type: "max",
              },
              {
                name: "最小值",
                formatter: "{b}:{c}",
                type: "min",
              },
            ],
          },
          data: [],
        };
        legend.push({
          name: item.name,
          icon: "roundRect",
        });
        selectLegend[item.name] = count++ < 6 ? true : false;
        var list = [];
        for (var j = 0, lens = item.data.length; j < lens; j++) {
          if (timeObject.hasOwnProperty(item.data[j][0])) {
            var temp = item.data[j];
            if (isNaN(parseFloat(temp)) || isnull(parseFloat(temp))) {
              temp = undefined;
            }
            list.push(temp);
          }
        }
        var resultList = [];
        for (var j = 1, len1 = list.length; j < len1; j++) {
          var item = list[j];
          var last = list[j - 1];
          if (
            this.$historyTools.isNull(last[1]) ||
            this.$historyTools.isNull(item[1])
          ) {
            //任意一个无值则无法计算
            resultList.push([item[0], undefined]);
          } else if (last[1] == 0) {
            //为0无法计算
            resultList.push([item[0], undefined]);
          } else {
            resultList.push([
              item[0],
              cutDigital(((item[1] - last[1]) / last[1]) * 100),
            ]);
          }
        }
        nitem.data = resultList;
        nl.push(nitem);
      }
      var chart = this.$refs.vchart;
      var options = chart.getOptions();
      options.series = nl;
      options.legend.data = legend;
      options.legend.selected = selectLegend;
      //如果数量太多就控制一下缩放
      if (
        Object.keys(this.timeObject).length > 144 &&
        options.dataZoom[0].end - options.dataZoom[0].start > 20
      ) {
        options.dataZoom[0].start = 0;
        options.dataZoom[0].end = 10;
        options.dataZoom[1].start = 0;
        options.dataZoom[1].end = 10;
      }
      options.title.text = this.nowDevice.name;
      // console.log("数据",options);
      chart.setData(options, true);
    },
    selectInterval(interval) {
      this.timeInterval = interval;
    },
  },
};
</script>

<style scoped lang="scss">
.myhistoryAnalysis {
  .con {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;

    .search-input-btn {
      width: 100%;
      height: 36px;

      .my-search-i {
        width: 100%;
        display: flex;
        align-items: center;
      }
    }

    .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 15px;
    }

    .tree-left {
      width: 3rem;
      height: 100%;
      padding: 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .btns {
        display: flex;
        // justify-content: space-evenly;
        margin-bottom: 8px;

        button {
          margin-right: 12px;
        }

        .el-button--mini {
          padding: 7px 10px !important;
        }

        .el-button + .el-button {
          margin-left: 0px;
        }
      }

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }
    }

    .right-table {
      width: calc(100% - 3.08rem);
      height: 100%;
      padding: 2px 20px 20px 20px;
      box-sizing: border-box;
      background-color: #fff;
      position: relative;
    }
  }
}
</style>
